import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar021 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.25 17.553v-.084m5.063.084v-.084m0-4.5v-.085m4.5.085v-.085M3.874 8.47h15.75M5.911 2v1.688M17.375 2v1.688m0 0H6.125A3.375 3.375 0 0 0 2.75 7.063v11.25a3.375 3.375 0 0 0 3.375 3.375h11.25a3.375 3.375 0 0 0 3.375-3.375V7.063a3.375 3.375 0 0 0-3.375-3.375"
    />
  </svg>
);
export default SvgCalendar021;
